<footer class="bg-OUT-BlueBlack py-9 px-3 md:px-5 2xl:px-28 3xl:px-52">
  <section
    class="container mx-auto w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 border-y py-7 text-white"
  >
    <div class="flex flex-col gap-1.5">
      <h3 class="text-xl font-semibold">SHOP BY LOCATION</h3>
      <ul *ngFor="let state of states">
        <li>
          <a
            [routerLink]="['/used-tesla-for-sale']"
            [queryParams]="{ location: state }"
            class="text-[#ccc] hover:text-white transition-colors duration-colors text-[14px] lg:text-[16px]"
            >Used Tesla for Sale {{ state }}</a
          >
        </li>
      </ul>
    </div>

    <!-- Models -->
    <div class="flex flex-col gap-1.5">
      <h3 class="text-xl font-semibold">SHOP BY MODELS</h3>
      <ul *ngFor="let model of models">
        <li>
          <a
            [routerLink]="'..' + model.link"
            class="text-[#ccc] hover:text-white transition-colors duration-colors text-[14px] lg:text-[16px]"
            >{{ model.text }}</a
          >
        </li>
      </ul>
    </div>

    <!-- Support -->
    <div class="flex flex-col gap-1.5">
      <h3 class="text-xl font-semibold">SUPPORT</h3>
      <ul *ngFor="let link of supportLinks">
        <li>
          <a
            *ngIf="!link.unique"
            class="text-[14px] lg:text-[16px] text-[#ccc] hover:text-white transition-colors duration-colors"
            routerLink="{{ link.link }}"
            >{{ link.name }}</a
          >
          <a
            *ngIf="link.unique"
            class="text-[14px] lg:text-[16px] text-[#ccc] hover:text-white transition-colors duration-colors"
            href="{{ link.link }}"
            >{{ link.name }}</a
          >
        </li>
      </ul>
    </div>
  </section>
  <section>
    <div
      class="container px-3 2xl:px-52 mx-auto text-white text-center mt-3 text-xs"
    >
      <p>
        Only Used Tesla (OUT) is an independent organization and is not
        affiliated with Tesla Motors, Inc. or its subsidiaries. Tesla, Tesla
        Motors, Tesla Roadster, Model S, Model X, and the “Tesla”, “T” and
        “Tesla and T in Crest” designs are trademarks or registered trademarks
        of Tesla Motors, Inc. in the United States and other countries.
      </p>
    </div>
  </section>
</footer>
